import { render, staticRenderFns } from "./LoginLite.vue?vue&type=template&id=68b84b33&scoped=true"
import script from "./LoginLite.vue?vue&type=script&lang=js"
export * from "./LoginLite.vue?vue&type=script&lang=js"
import style0 from "./LoginLite.vue?vue&type=style&index=0&id=68b84b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b84b33",
  null
  
)

export default component.exports